var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { light: "", fullscreen: "" },
      model: {
        value: _vm.isDialog,
        callback: function ($$v) {
          _vm.isDialog = $$v
        },
        expression: "isDialog",
      },
    },
    [
      _vm.isDialog
        ? _c("v-card", [
            _c("div", { staticClass: "thisDialog text-center" }, [
              _c(
                "div",
                { staticClass: "d-inline-block" },
                [
                  [
                    _c("div", { staticClass: "hidden-sm-and-up" }, [
                      _c("h4", { staticClass: "pt-2" }, [
                        _vm._v("Deine Tischummer?"),
                      ]),
                      _c("div", [_vm._v("(siehe Nummer auf dem Tisch)")]),
                    ]),
                    _c("h3", { staticClass: "pt-2 hidden-xs-only" }, [
                      _vm._v("Bitte gib deine Tischummer ein:"),
                    ]),
                  ],
                  _c("div", { staticClass: "spacer-15" }),
                  _c("div", { staticClass: "d-inline-block" }, [
                    _c("table", { staticClass: "table-collapse ntable" }, [
                      _c("tr", [
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "num noselect",
                              on: {
                                "&click": function ($event) {
                                  return _vm.clickNum("1")
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "superCenter" }, [
                                _vm._v("1"),
                              ]),
                            ]
                          ),
                        ]),
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "num noselect",
                              on: {
                                "&click": function ($event) {
                                  return _vm.clickNum("2")
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "superCenter" }, [
                                _vm._v("2"),
                              ]),
                            ]
                          ),
                        ]),
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "num noselect",
                              on: {
                                "&click": function ($event) {
                                  return _vm.clickNum("3")
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "superCenter" }, [
                                _vm._v("3"),
                              ]),
                            ]
                          ),
                        ]),
                      ]),
                      _c("tr", [
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "num noselect",
                              on: {
                                "&click": function ($event) {
                                  return _vm.clickNum("4")
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "superCenter" }, [
                                _vm._v("4"),
                              ]),
                            ]
                          ),
                        ]),
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "num noselect",
                              on: {
                                "&click": function ($event) {
                                  return _vm.clickNum("5")
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "superCenter" }, [
                                _vm._v("5"),
                              ]),
                            ]
                          ),
                        ]),
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "num noselect",
                              on: {
                                "&click": function ($event) {
                                  return _vm.clickNum("6")
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "superCenter" }, [
                                _vm._v("6"),
                              ]),
                            ]
                          ),
                        ]),
                      ]),
                      _c("tr", [
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "num noselect",
                              on: {
                                "&click": function ($event) {
                                  return _vm.clickNum("7")
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "superCenter" }, [
                                _vm._v("7"),
                              ]),
                            ]
                          ),
                        ]),
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "num noselect",
                              on: {
                                "&click": function ($event) {
                                  return _vm.clickNum("8")
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "superCenter" }, [
                                _vm._v("8"),
                              ]),
                            ]
                          ),
                        ]),
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "num noselect",
                              on: {
                                "&click": function ($event) {
                                  return _vm.clickNum("9")
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "superCenter" }, [
                                _vm._v("9"),
                              ]),
                            ]
                          ),
                        ]),
                      ]),
                      _c("tr", [
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "num noselect",
                              on: {
                                "&click": function ($event) {
                                  return _vm.clickNum("0")
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "superCenter" }, [
                                _vm._v("0"),
                              ]),
                            ]
                          ),
                        ]),
                        _c("td", { attrs: { colspan: "2" } }, [
                          _c(
                            "div",
                            {
                              staticClass: "num noselect",
                              staticStyle: { width: "100%" },
                              on: {
                                "&click": function ($event) {
                                  return _vm.reset.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "superCenter" }, [
                                _vm._v("RESET"),
                              ]),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "mt-3 mb-3" }, [
                    _c("div", {
                      staticClass: "displayTischnummer d-inline-block",
                      domProps: { innerHTML: _vm._s(_vm.num) },
                    }),
                  ]),
                  _c(
                    "div",
                    { staticClass: "text-center" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "text-none btn-df mr-4 ml-2 mt-7",
                          nativeOn: {
                            "&click": function ($event) {
                              $event.stopPropagation()
                              return _vm.goAhead.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v(" Weiter ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "text-center" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "text-none btn-df mt-7",
                          nativeOn: {
                            "&click": function ($event) {
                              $event.stopPropagation()
                              return _vm.handleDismiss.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v(" Abbrechen ")]
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c("div", { staticClass: "pb-3" }),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }